import React, { useState } from "react";
import classes from './Newletter.module.css'
import { toast } from "react-toastify";
import data from '../../Data.json';
import { useSelector } from "react-redux";
import axios from "axios";

const NewsLetter = () => {
  const language = useSelector((state) => state.products.selectedLanguage[0].Language);
  const [email, setEmail] = useState("");

  const addToNewsletter = async (email) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_TESTING_API}/newsletter`,
        { email, ecom_type: `${process.env.REACT_APP_ECOM_TYPE}` }
      );
      setEmail('')
      // console.log("Email added to newsletter:", response.data);
      // You can display a success message if needed
      toast.success(`${language === 'eng' ? "" : 'Abonné avec succès'}`, {
        position: "top-right",
        autoClose: 1500,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0 ,
        theme: "colored",
        })
    } catch (error) {
      // console.error("Error adding email to newsletter:", error.response.data.error.email[0]);
      // You can display an error message if needed
      toast.error(error.response.data.error.email[0] && `${language === 'eng' ? `The email has already been subscribed.` : "L'email a déjà été souscrit."}`, {
        position: "top-right",
        autoClose: 1500,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0 ,
        theme: "colored",
        });
    }
  };

  
  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = () => {
    // Validate email here if needed
    if (!validateEmail(email)) {
      toast.error(`${language === 'eng' ? "" : "Veuillez entrer une adresse email valide."}`);
      return;
    }

    addToNewsletter(email);
  };

  const validateEmail = (email) => {
    // Email validation regex pattern
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(email);
  };
  return (
    <div className={classes.newsletter_con}>
      <div className={classes.content}>
      <div className={classes.description}>
        <p className=" flex justify-center text-center " style={{textAlign:'start'}}>
        {data.HomePage.NewsLetter.title[language]}
        </p>
      </div>
      <div className={classes.button}>
        <input type="text" name="email" value={email} onChange={handleChange} placeholder={data.HomePage.NewsLetter.email[language]} className={classes.desktop}/>
        {/* <input type="text" name="email" value={email} onChange={handleChange} placeholder={data.HomePage.NewsLetter.title[language]} className={classes.mobile}/> */}
        <button onClick={()=> {handleSubmit() }}>{data.HomePage.NewsLetter.button[language]}</button>
      </div>
      </div>
    </div>
  );
};

export default NewsLetter;
